import {
    getIsUserCustomPropertiesInitializedPromise,
    getUserCustomProperties,
} from '../../lib/utils/userCustomProperties';
import { DayActivity } from '../schema/DayActivity';
import { Modules } from '../schema/Modules';
import { UserCustomPropertiesKeys } from '../schema/UserCustomProperties';

/**
 * Api to return the user activity of a particular module
 * @param module module to get the user activity
 */
export const getModuleUserActivity = async (module: Modules): Promise<DayActivity[]> => {
    await getIsUserCustomPropertiesInitializedPromise();
    const userCustomProperties = getUserCustomProperties();
    if (userCustomProperties) {
        if (UserCustomPropertiesKeys.userMonthlyActivity in userCustomProperties) {
            return userCustomProperties[UserCustomPropertiesKeys.userMonthlyActivity][module];
        }
    }
    return null;
};
